// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2xFQY","signatureBlock":"Footer_signatureBlock__2Tf2P","signature":"Footer_signature__1TniM"};